import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-suggest-title',
  templateUrl: './suggest-title.component.html',
  styleUrls: ['./suggest-title.component.scss']
})

export class SuggestTitleComponent implements OnInit, AfterViewInit, OnDestroy {

	textSource = "";
	userID = 0;
	courseID = 0;
	courseUnits?: any[];
	selectedUnit = -1;
	unitLessons?: any[];
	selectedLesson = -1;
	lessonHeadings?: any[];
	selectedHeading = -1;
	headingText = "";
	titleWords = 5;
	numTitles = 3;

	suggestTitleLoading = false;
	suggestTitleSuccess = false;
	suggestTitleError = false;
	suggestTitleBtnDisabled = true;
	updateHeadingTitleBtnDisabled = true;
	suggestTitleResultMsg = "";
	suggestedTitles = [];
	selectedTitle = "";
	updateHeadingTitleLoading = false;
	updateHeadingTitleSuccess = false;
	updateHeadingTitleError = false;

	showCourseSub!: Subscription;
	suggestTitleSub!: Subscription;
	taskStatusCelerySub!: Subscription;
	updateHeadingTitleSub!: Subscription;
  
	constructor(private dataService: ApiService, private route: ActivatedRoute) { }

	ngOnInit() {
		this.userID = this.dataService.getUserID();
		this.courseID = +this.route.snapshot.paramMap.get('id')!;
	}
	
	ngAfterViewInit() {
		this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
		.subscribe(
			course => {
				this.courseUnits = course.units;
			},
			error => {
				console.log(error);
			},
		);
	}

	ngOnDestroy() {
		this.showCourseSub?.unsubscribe();
		this.suggestTitleSub?.unsubscribe();
		this.taskStatusCelerySub?.unsubscribe();
		this.updateHeadingTitleSub?.unsubscribe();
	}

	selectUnit(unitId: number) {
		this.unitLessons = this.courseUnits?.find((unit) => {
			return +unitId === +unit.id;
		})?.lessons!;

		this.selectedLesson = -1;
		this.selectedHeading = -1;
		this.lessonHeadings = undefined;
		this.suggestTitleBtnDisabled = true;

		if (this.unitLessons?.length === 1) {
			this.selectLesson(this.unitLessons[0].id);
		}
	}

	selectLesson(lessonId: number): void {
		this.lessonHeadings = this.unitLessons?.find((lesson) => {
			return +lessonId === +lesson.id;
		})?.headings!;

		this.selectedLesson = +lessonId;
		this.selectedHeading = -1;
		this.suggestTitleBtnDisabled = true;

		if (this.lessonHeadings?.length === 1) {
			this.selectHeading(this.lessonHeadings[0].id);
		}
	}

	selectHeading(headingId: number): void {
		let heading = this.lessonHeadings?.find((heading) => {
			return +headingId === +heading.id;
		})!;
		console.log(heading);
		this.headingText = heading.content.trim();
		this.selectedHeading = +headingId;

		this.suggestTitleBtnDisabled = false;
	}

	suggestTitle() {
		this.suggestTitleLoading = true;
		this.suggestTitleSuccess = false;
		this.suggestTitleError = false;
		this.suggestTitleBtnDisabled = true;

		// console.log(this.headingText);
		this.suggestTitleSub = this.dataService.suggestTitle(this.headingText, this.titleWords, this.numTitles)
		.subscribe(
			data => {
				console.log(data);
				let task = data.id;

				let interval = 1000 * 60 * 0.07;
				let idinterval = setInterval(() => {
					this.taskStatusCelerySub = this.dataService.taskStatusCelery('title', task)
					.subscribe(
						data => {
							console.log(data);
							let status = data.status;
							// let status = data.result.titles;
							// let status = data.result.message;

							if (status !== "STARTED") {
								window.clearTimeout(idinterval);
								this.suggestTitleBtnDisabled = false;
								this.suggestTitleLoading = false;
								
								if (status === "ERROR") { // || this.suggestedTitles === null || this.suggestedTitles!.length === 0) {
									// window.clearTimeout(idinterval);
									this.suggestTitleError = true;
									this.suggestTitleSuccess = false;
									return;
								}
	
								if (status === "SUCCESS") {
									window.clearTimeout(idinterval);
									this.suggestTitleSuccess = true;
									this.suggestTitleError = false;
	
									this.suggestTitleResultMsg = data.result.message;
									this.suggestedTitles = data.result.titles;
									console.log(this.suggestedTitles)
								}

							}

						},
						error => {
							console.log(error);
							window.clearTimeout(idinterval);
						},
					);
				}, interval);
			},
			error => {
				console.log(error);

				// this.suggestTitleError = true;
				this.suggestTitleLoading = false;
				this.suggestTitleSuccess = false;
			},
		);
	}

	changeSelectedTitle() {
		this.updateHeadingTitleBtnDisabled = this.selectedTitle.length === 0;
	}

	updateHeadingTitle() {
		this.updateHeadingTitleBtnDisabled = true;
		this.updateHeadingTitleLoading = true;
		this.updateHeadingTitleSuccess = false;
		this.updateHeadingTitleError = false;

		this.updateHeadingTitleSub = this.dataService.updateHeading(this.selectedHeading, this.selectedTitle, undefined)
		.subscribe(
			data => {
				console.log(data);
				this.updateHeadingTitleBtnDisabled = false;
				this.updateHeadingTitleSuccess = true;
				this.updateHeadingTitleLoading = false;
				this.updateHeadingTitleError = false;
				
				this.suggestTitleBtnDisabled = false;
				this.suggestTitleSuccess = false;
				this.suggestTitleError = false;
				this.selectedLesson = -1;
				this.selectedHeading = -1;
			},
			error => {
				console.log(error);
				this.updateHeadingTitleBtnDisabled = false;
				this.updateHeadingTitleError = true;
				this.updateHeadingTitleLoading = false;
				this.updateHeadingTitleSuccess = false;
			},
		);
	}

}
